var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" container-fluid container-fixed-lg bg-white app-table-container"})}
var staticRenderFns = []

export { render, staticRenderFns }